var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',{staticClass:"home-title",class:{ pgray: !_vm.nightMode, 'text-light': _vm.nightMode }},[_c('b',[_vm._v("JooYeong")]),_vm._v(" Kim")]),_c('span',{staticClass:"home-subtitle",class:{ pgray: !_vm.nightMode, 'text-light': _vm.nightMode }},[_vm._v("HCI Researcher @ GIST")])])
}
var staticRenderFns = []

export { render, staticRenderFns }